import { FaBuilding, FaBuildingUser, FaUsers } from "react-icons/fa6";
import { BsFillBuildingsFill } from "react-icons/bs";
import { GiOrganigram } from "react-icons/gi";
import { FaFileContract } from "react-icons/fa";

export const linksAdmin = [
	{ label: "Usuarios", path: "/usuarios", icon: FaUsers },
	{ label: "Clientes", path: "/clientes", icon: FaBuildingUser },
	{ label: "Clientes Defensa Fiscal", path: "/clientes_df", icon: BsFillBuildingsFill },
	{ label: "Empresas", path: "/empresa", icon: FaBuilding },
	{ label: "Contratos", path: "/contratosAdmin", icon: FaFileContract },
	{ label: "Organigrama", path: "/organigrama", icon: GiOrganigram },
];

export const linksAdminNotSuper = [
	{ label: "Mis contadores", path: "/contadores", icon: FaUsers },
	{ label: "Mis empresas", path: "/empresasAdmin", icon: BsFillBuildingsFill },
	{ label: "Clientes", path: "/clientes", icon: FaBuildingUser },
	{ label: "Empresas", path: "/empresa", icon: FaBuilding },
	{ label: "Organigrama", path: "/organigrama", icon: GiOrganigram },
];
